import CityServicePage from "@/pages/city-service/CityServicePage";
import { mississaugaResidential } from "@/mocks/cityServiceData";
export default function Page() { return <CityServicePage config={mississaugaResidential} />; }
